// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2530": "e96a97f91d26","5336": "5083bc5218c4","8095": "86e8e0806f0a","8164": "b7791ad4db58","8990": "7d69c8cdd354",}[chunkId] + ".css"
}